module.exports = __webpack_public_path__ + "img/ET411.616.a6adad04.png";